/**
 * @file Map-marker-line-control.tsx
 * @module MapMarkerLineControl
 * @description Līnijas zīmēšanas vadīkla Karšu pārlūka marķieru komponentam.
 *              Izmanto OpenLayers Draw interakciju MultiLineString ģeometrijas izveidei.
 *              Atbalsta piesaistes (sticky) režīmu un brīvroku (freehand) zīmēšanu
 *              ar Shift taustiņu.
 */
import Draw from "ol/interaction/Draw";
import { useEffect, useState } from "react";
import VectorSource from "ol/source/Vector";
import { Map } from "ol";
import { getDrawStyle } from "./Draw-styles";
import { useTranslation } from "react-i18next";
import { Tooltip } from "antd";

let LINE_CONTROL!: Draw;

const CONTROL_ID = "draw_line";

export const MapMarkerLineControl = ({ source, map, readOnly }: { source: VectorSource; map: Map; readOnly?: boolean }) => {
	const [active, setActive] = useState(false);
	const [t] = useTranslation();

	useEffect(() => {
		if (
			!map ||
			!source ||
			!!map
				.getInteractions()
				.getArray()
				.find((i) => i.get("id") === CONTROL_ID)
		)
			return;

		LINE_CONTROL = new Draw({
			type: "MultiLineString",
			source,
			style: getDrawStyle(),
		});
		LINE_CONTROL.setProperties({ group: "draw", id: CONTROL_ID });
		LINE_CONTROL.setActive(false);

		map.addInteraction(LINE_CONTROL);

		LINE_CONTROL.on("change:active", (e) => setActive(!e.oldValue));
	}, [map, source]);

	return (
		<Tooltip
			title={t("addLineTooltip")}
			overlayClassName="font-bold"
			color="#4d4f50"
			placement="left"
			overlayInnerStyle={{ padding: ".25rem .75rem", borderRadius: ".25rem", textAlign: "center" }}
		>
			<span className={readOnly ? "cursor-not-allowed" : ""}>
				<button
					type="button"
					onClick={() => {
						const newValue = !LINE_CONTROL.getActive();
						map
							?.getInteractions()
							.getArray()
							.filter((i) => i instanceof Draw)
							.forEach((i) => i.setActive(false));
						LINE_CONTROL.setActive(newValue);
					}}
					disabled={readOnly}
					className={`bg-white p-6 border-2 border-white active:ring-4 active:ring-npp-blue-500 active:border-npp-grey-500 flex items-center rounded-full shadow-md transition-all disabled:!bg-npp-grey-300 disabled:!border-npp-grey-300 disabled:!ring-0 ${
						active && "ring-npp-blue-500 !border-npp-grey-500 ring-4"
					}`}
				>
					<span className="material-icons">timeline</span>
				</button>
			</span>
		</Tooltip>
	);
};
